"use client";
import dynamic from "next/dynamic";
import { useCalculatorModal, useCartModal, useLoginModal } from "states/modals";

const Login = dynamic(() => import("./header.defered").then(({ LoginModal }) => LoginModal), {
  ssr: false,
});

const Calculator = dynamic(() => import("./header.defered").then(({ CalculatorModal }) => CalculatorModal), {
  ssr: false,
});

const Cart = dynamic(() => import("./header.defered").then(({ CartModal }) => CartModal), {
  ssr: false,
});

export function CalculatorModal() {
  const { open, setOpen } = useCalculatorModal();
  return <Calculator open={open} onClose={setOpen} />;
}

export function LoginModal() {
  const { open, setOpen } = useLoginModal();
  return <Login open={open} onClose={setOpen} />;
}

export function CartModal() {
  const { open, setOpen } = useCartModal();
  return <Cart open={open} onClose={setOpen} />;
}
